import Vue from 'vue'
import App from './App.vue'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import YnPlug from '../packages/index'
import axios from '../packages/utils/axios'


Vue.use(ViewUI)
Vue.use(YnPlug)
Vue.prototype.$axios = axios
Vue.config.productionTip = false


new Vue({
  render: h => h(App)
}).$mount('#app')

console.log("BASE:" + Vue.prototype.$axios.baseURL)